import React, { Component } from 'react';

class Title extends Component {
  render() {
    return (
      <div>
        <h4 className='title-container__title'> Team Capacity Calculator </h4>
      </div>
    );
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/components/Title.jsx